import {Injectable} from '@angular/core';
import {ISchedule} from '@interfaces/schedule';
import {Observable, throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ErrorService} from '@services/error/error.service';
import {catchError, share} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {ToggleGlobalLoader} from '@store/loader';
import {IDeviceArea} from '@interfaces/devices';

@Injectable({
    providedIn: 'root'
})

export class ScheduleService {
    constructor(private http: HttpClient,
                private errorService: ErrorService,
                private store: Store) {
    }

    public convertIntoUnixCronFormat(data: string, repetitionType: 'weekDays' | 'daysCount'): string {
        if (repetitionType === 'weekDays') {
            return `* * * * ${data.toUpperCase()}`;
        } else {
            return `* * */${data} * *`;
        }
    }

    public convertFromUnixCronFormat(data: string): { type: string, data: string } {
        let scheduleType;
        const scheduleTypeNum = data.split('').filter(item => item !== ' ').findIndex(item => item !== '*');
        const scheduleData = data.split('').filter(item => item !== '*' && item !== ' ' && item !== '/').join('');
        if (scheduleTypeNum === 3) scheduleType = 'specificDates';
        else scheduleType = 'weekDays';
        return {
            type: scheduleType,
            data: scheduleData
        };
    }

    public createEvent(event: ISchedule): Observable<IDeviceArea[]> {
        this.store.dispatch(new ToggleGlobalLoader(true));
        const sub = this.http.post<IDeviceArea[]>('device-area', event)
            .pipe(
                share(),
                catchError(err => {
                    this.errorService.showError(err);
                    return throwError(err);
                })
            );

        sub.subscribe(() => this.store.dispatch(new ToggleGlobalLoader(false)));

        return sub;
    }

    public updateEvent(event: ISchedule, id: number): Observable<any> {
        const sub = this.http.patch(`device-area/${id}`, event)
            .pipe(
                share(),
                catchError(err => {
                    this.errorService.showError(err);
                    return throwError(err);
                })
            );

        return sub;
    }

    public deleteEventDevice(id: number): Observable<any> {
        this.store.dispatch(new ToggleGlobalLoader(true));
        const sub = this.http.delete(`device-area/${id}`)
            .pipe(
                share(),
                catchError(err => {
                    this.errorService.showError(err);
                    return throwError(err);
                })
            );

        sub.subscribe(() => this.store.dispatch(new ToggleGlobalLoader(false)));

        return sub;
    }

    public deleteEventGroup(id: number): Observable<any> {
        this.store.dispatch(new ToggleGlobalLoader(true));
        const sub = this.http.delete(`device-area/group/${id}`)
            .pipe(
                share(),
                catchError(err => {
                    this.errorService.showError(err);
                    return throwError(err);
                })
            );

        sub.subscribe(() => this.store.dispatch(new ToggleGlobalLoader(false)));

        return sub;
    }

    public deleteDevicesHotSchedule(devicesIds: number[], hotPlaylistId: number): Observable<any> {
        return this.http.request('delete', 'hot-schedule/devices', {body: {devicesIds, hotPlaylistId, areaId: 4}})
            .pipe(
                catchError(err => {
                    this.errorService.showError(err);
                    return throwError(err);
                })
            );
    }

    public deleteGroupsHotSchedule(groupsIds: number[], hotPlaylistId: number): Observable<any> {
        return this.http.request('delete', 'hot-schedule/groups', {body: {groupsIds, hotPlaylistId, areaId: 4}})
            .pipe(
                catchError(err => {
                    this.errorService.showError(err);
                    return throwError(err);
                })
            );
    }

    public setHotScheduleWithDevices(devicesIds: number[], hotPlaylistId: number): Observable<any> {
        return this.http.post('hot-schedule/devices', {devicesIds, hotPlaylistId, areaId: 4})
            .pipe(
                catchError(err => {
                    this.errorService.showError(err);
                    return throwError(err);
                })
            );
    }

    public setHotScheduleWithGroups(groupsIds: number[], hotPlaylistId: number): Observable<any> {
        return this.http.post('hot-schedule/groups', {groupsIds, hotPlaylistId, areaId: 4})
            .pipe(
                catchError(err => {
                    this.errorService.showError(err);
                    return throwError(err);
                })
            );
    }
}
